import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {Button, Col, Row} from 'antd';
import {makeAction} from '../../../redux/actions/makeAction';
import {OPEN_MODAL} from '../../../redux/actions/actionTypes';
import {connect} from 'react-redux';
import TranslatedText from '../../TranslatedText';

const ProfileItem = ({label = null, children, value, editable = false, modalId = '', openModal, onChange = _.noop, large = false}) => {
  return (
    <Row type="flex" justify="space-between" align="middle" gutter={10}>
      <Col xs={24} xl={large ? 6 : 8} className="profile-label-col">
        {label}
      </Col>
      <Col xs={16} xl={large ? 16 : 12} className="profile-content-col">
        {
          _.isUndefined(value)
            ? null
            : _.isNull(value)
            ? <span className="error-msg"><TranslatedText transKey="profile.common.notset"/></span>
            : <span>{value}</span>
        }
      </Col>
      <Col xs={8} xl={large ? 2 : 4} className="profile-actions-col">
        {
          editable && <Button
            type="primary"
            onClick={() => {
              if (modalId) {
                openModal({id: modalId});
              }
              if (onChange) {
                onChange();
              }
            }}
          >
            <TranslatedText transKey="profile.common.editButton"/>
          </Button>
        }
        {children}
      </Col>
    </Row>
  );
};

ProfileItem.propTypes = {
  value: PropTypes.any,
  label: PropTypes.any,
  children: PropTypes.any,
  editable: PropTypes.bool,
  modalId: PropTypes.string,
  openModal: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  large: PropTypes.bool,
};

const mapDispatchToProps = {
  openModal: makeAction(OPEN_MODAL),
};

export default connect(
  null,
  mapDispatchToProps
)(ProfileItem);



// WEBPACK FOOTER //
// /src/components/pages/profile/ProfileItem.jsx